import { useParams } from "react-router-dom";

import { ErrorMessage } from "@/app/components/error-message";
import { LoadingScreen } from "@/components/loading-screen";
import { useLicenses } from "@/features/licensing/api/fetch-licenses";
import { AddonsForm } from "@/features/licensing/components/addons.form";
import { FeatureFlagsForm } from "@/features/licensing/components/feature-flags.form";
import { OrganisationLicenseForm } from "@/features/licensing/components/organisation-licence.form";
import { useGetOrganisation } from "@/features/organisations/api/get-organisation";
import { OnboardingHeader } from "@/features/registration/components/onboarding-header";

export function OrganisationLicense() {
  const { id } = useParams();
  const { data, isLoading, isSuccess, isError, error } = useGetOrganisation({
    id: id ?? "",
  });
  const { isLoading: isLoadingLicenses } = useLicenses();

  if (isLoading || isLoadingLicenses)
    return (
      <div>
        <OnboardingHeader
          title="License Details"
          description="View and manage Organisation license details"
          className="mb-6"
        />
        <LoadingScreen />
      </div>
    );

  if (isError || !isSuccess)
    return (
      <div>
        <OnboardingHeader
          title="License Details"
          description="View and manage Organisation license details"
          className="mb-6"
        />
        <ErrorMessage error={error} />
      </div>
    );

  return (
    <div>
      <OnboardingHeader
        title="License Details"
        description="View and manage Organisation license details"
        className="mb-6"
      />

      <div className="space-y-6">
        <OrganisationLicenseForm initialData={data} />
        <AddonsForm initialData={data} />
        <FeatureFlagsForm initialData={data} />
      </div>
    </div>
  );
}
